import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["href"];
export default {
  __name: 'NavBarHeaderTag',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    to: {
      type: Object,
      required: false
    },
    href: {
      type: String,
      required: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return __props.to ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: __props.to,
        class: "nav-item"
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 3
      }, 8, ["to"])) : __props.href ? (_openBlock(), _createElementBlock("a", {
        key: 1,
        href: __props.href,
        target: "_blank",
        rel: "noopener noreferrer",
        class: "nav-item"
      }, [_renderSlot(_ctx.$slots, "default")], 8, _hoisted_1)) : (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: _normalizeClass(["nav-item", {
          'active': __props.active
        }])
      }, [_renderSlot(_ctx.$slots, "default")], 2));
    };
  }
};